<obg-timer
	*ngIf="sessionElapsedSeconds$ | async as sessionElapsedSeconds"
	[elapsedTimeInMillis]="sessionElapsedSeconds"
	[formattableText]="timerText"
>
</obg-timer>
